import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Grid, FormControl,
  InputLabel, Select, MenuItem } from '@material-ui/core';
import { actualizarMensaje } from '../../../redux/actions/actGlobal';
import AppBarModal from '../../general/AppBarModal';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import ListarDatos from '../../general/ListarDatos';
import { BtnCancelar, BtnForm, BtnSeleccion } from '../../general/BotonesAccion';
import { consulta } from '../../../global/js/funciones';
import { connect } from 'react-redux';

class ConvocatoriasBuscarUniversidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dato_buscar: '',
      pais_filtro: '',
      paises: [],
      instituciones: [],
      universidades: [],
      cargando: false,
      cargando_pais: false,
      modal_filtro_pais: false,
    }
  }

  async componentDidUpdate({ modalBuscarUniversidad }) {
    let { modalBuscarUniversidad: modalBuscarUniversidadNew } = this.props;
    if (modalBuscarUniversidadNew !== modalBuscarUniversidad) {
      this.setState({ cargando: true, pais_filtro: '' });
      await this.obtenerInstituciones();
    }
  }

  // Trae todas las instituciones con convenio activo. Se usa listar-instituciones y no
  // solicitud/convenio porque ese último filtra por estado de la solicitud y devuelve el
  // convenio completo (payload de varios MB).
  obtenerInstituciones = async () => {
    let { actualizarMensaje } = this.props;
    await consulta(`api/v1.0/internacionalizacion/listar-instituciones/`, null, null, (error, estado, resp) => {
      if (!error && estado === 200) {
        let instituciones = resp.instituciones ? resp.instituciones : [];
        let paises = instituciones.map(({ pais }) => pais).filter(Boolean);
        this.setState({
          instituciones,
          universidades: instituciones,
          paises: [...new Set(paises)].sort(),
          cargando: false,
        });
      } else {
        this.setState({ instituciones: [], universidades: [], paises: [], cargando: false });
        actualizarMensaje({ titulo: 'No se pudo cargar la lista de instituciones.', tipo: 'error', mostrar: true, tiempo: 6000 });
      }
    });
  }

  acciones = (data) => {
    let { seleccionadas } = this.props;
    const onClickSeleccionar = (data) => {
      this.props.seleccionar(data)
    }
    const onClickQuitar = (data) => {
      this.props.quitar(data)
    }

    return (
      seleccionadas.map(u => u.id).includes(data.id) ? <BtnCancelar callback = { () => onClickQuitar(data) } />
        : <BtnSeleccion callback = { () => onClickSeleccionar(data) } />
    );
  }

  // Filtra en memoria sobre la lista ya cargada. Sin país seleccionado muestra todo; con
  // un país sin coincidencias muestra vacío, no la lista completa.
  filtrarPaisesInstituciones = () => {
    let { pais_filtro, instituciones } = this.state;
    let universidades = pais_filtro ? instituciones.filter(({ pais }) => pais === pais_filtro) : instituciones;
    this.setState({ modal_filtro_pais: false, universidades });
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({ [name]: value });
  }

  render () {
    let { modalBuscarUniversidad, mostrarModalBuscarUniversidad } = this.props;
    let { universidades, cargando, modal_filtro_pais, cargando_pais, pais_filtro, paises } = this.state;
    return (
      <>
        <Dialog open = { modalBuscarUniversidad } onClose = { mostrarModalBuscarUniversidad.bind(this, false) } aria-labelledby = "form-dialog-title" fullWidth = { true } maxWidth = "sm">
          <AppBarModal titulo = { '¡ Buscar Universidad !' } mostrarModal = { mostrarModalBuscarUniversidad } titulo_accion = "" accion = "" />
          <DialogContent className = 'scroll' style = { { padding: 0 } }>
            {
              cargando ? <TareasTerminadas mensaje = 'Cargando..' marginTop = '7%' imagen = { emma_w } widthImg = "7%" /> :
                <ListarDatos
                  datos = { universidades }
                  titulo = 'Lista de Universidades'
                  opciones = { true }
                  buscar = { true }
                  filtrar = { true }
                  actfiltrar = { () => this.setState({ modal_filtro_pais: true }) }
                  sub_titulo = 'Universidades'
                  id = 'tbl_universidades_seleccion'
                  acciones = { row => this.acciones(row) }
                  fila_principal = { ({ institucion }) => institucion ? institucion.toUpperCase() : 'SIN NOMBRE' }
                  filas = { [
                    {'nombre': 'Código del convenio: ', 'id': 'codigo_inter', 'mostrar': ({ codigo_convenio }) => codigo_convenio ? codigo_convenio :"No registra"},
                    {'nombre': 'País: ', 'id': 'pais', 'mostrar': ({ pais }) => pais ? pais :"No registra"},
                    {'nombre': 'Ciudad: ', 'id': 'ciudad', 'mostrar': ({ ciudad }) => ciudad ? ciudad :"No registra"},
                  ] }
                />
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto = "CERRAR" callback = { () => mostrarModalBuscarUniversidad(false) } />
          </DialogActions>
        </Dialog>

        <Dialog fullWidth = { true } maxWidth = "xs" open = { modal_filtro_pais } onClose = { () => this.setState({ modal_filtro_pais: false })} aria-labelledby = "alert-dialog-title" aria-describedby = "alert-dialog-description">
          <AppBarModal titulo = '¡ Aplicar Filtros !' mostrarModal = { () => this.setState({ modal_filtro_pais : false }) } titulo_accion = "Limpiar" accion = { () => this.setState({ pais_filtro: '' }) } />
          <DialogContent className = 'scroll'>
            {
              !cargando_pais ?
                <Grid container spacing = { 3 } className = 'margin_cont'>
                  <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }>
                    <FormControl className = 'form-control'>
                      <InputLabel htmlFor = "pais_filtro">Seleccione País</InputLabel>
                      <Select inputProps = { { name: 'pais_filtro', id: 'pais_filtro' } } value = { pais_filtro } onChange = { this.onChange } required = { true }>
                        { paises.map((pais, i) => <MenuItem key = { i } value = { pais }>{ pais }</MenuItem>) }
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                : <TareasTerminadas imagen = { emma_w } mensaje = 'Cargando...' widthImg = '5%' marginTop = '5%' />
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto = "CANCELAR" callback = { () => this.setState({ modal_filtro_pais: false }) } />
            <BtnForm texto = "FILTRAR" callback = { () => this.filtrarPaisesInstituciones() } />
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

const mapDispatchToProps = { actualizarMensaje }

ConvocatoriasBuscarUniversidad.propTypes = {
  actualizarMensaje: PropTypes.func.isRequired,
  modalBuscarUniversidad: PropTypes.bool.isRequired,
  mostrarModalBuscarUniversidad: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(ConvocatoriasBuscarUniversidad);
